import { useMemo } from "react";

export const FILE_GUID_REGEX =
  /\[(.*?)\]\(file-guid:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\s+"(.*?)")?\)/g;

export const useMarkdownContent = (content: string) => {
  return useMemo(() => {
    if (!content) return "";

    // ファイル GUID 記法を除去し、改行コードだけ LF へ統一する。
    // Markdown の改行解釈は remark-breaks に任せ、原文構造を壊さない。
    return content.replace(FILE_GUID_REGEX, "").replace(/\r\n?/g, "\n");
  }, [content]);
};
